<template>
    <div class="app-container">
        <div class="not-found">
            404
        </div>
    </div>
</template>

<script>
    export default {
        name: 'NotFound',
        data () {
            return {
            };
        },
    }
</script>

<style>
.not-found {
    margin-top: 100px;
    font-size: 100px;
    color: #A8AEB3;
    text-align: center;
}
</style>
